import { getDaysCountToPremiumPreviewExpired } from '../utils/getDaysCountToPremiumPreviewExpired';
import { updatePremiumPreviewData } from '../actions/premiumPreviewActions';
import { PremiumPreviewType } from '../store/schema/PremiumPreviewData';
import { ProofingViewState } from '../store/schema/ProofingViewState';
import { getPremiumPreviewType } from './getPremiumPreviewType';

export function setPremiumPreviewData(
    finalDatePremiumDemo: string | undefined,
    premiumSuggestionsCount: number | undefined,
    viewState: ProofingViewState
) {
    const premiumPreviewType: PremiumPreviewType = getPremiumPreviewType();
    if (premiumPreviewType !== PremiumPreviewType.None) {
        const countDays: number = getDaysCountToPremiumPreviewExpired(finalDatePremiumDemo);
        updatePremiumPreviewData(
            viewState,
            premiumPreviewType,
            countDays,
            false /* shouldUpdateOptionSettings*/,
            premiumSuggestionsCount
        );
    }
}
